import { defineComponent } from 'vue';
export default defineComponent({
  name: 'Banner',
  props: {
    image: {
      type: String,
      required: true
    },
    title: {
      type: String
    },
    height: {
      type: Number,
      default: 280
    }
  },
  setup: function () {
    return {};
  }
});